export const BASE_APPROVAL_URL = "/user/approval";

export const APPROVAL_URL = BASE_APPROVAL_URL + "/cycle";
export const SELLING_APPROVAL_URL = APPROVAL_URL + "/sell_payment";
export const SELLING_APPROVAL_COMPLETED_URL = APPROVAL_URL + "/sell_payment/completed";
